import React from "react";
import * as Mui from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	label: {
		display: "block",
		marginBottom: 8,
		fontSize: 14,
		lineHeight: "20px",
		color: theme.palette.custom.textSecondary, // #5f6368
	},
	asterisk: {
		color: theme.palette.error.main,
		marginLeft: 2,
	},
	input: {
		"& .MuiOutlinedInput-root": {
			borderRadius: 4,
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.divider, // #ebebeb — Figma "Border/field-active"
		},
		"& .MuiOutlinedInput-input": {
			padding: "12px 16px",
		},
	},
	error: {
		color: theme.palette.error.main,
		fontSize: "0.75rem",
		fontWeight: "bold",
		marginTop: 4,
	},
}));

interface Props {
	label: string;
	value: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	required?: boolean;
	error?: boolean;
	helperText?: React.ReactNode;
	type?: string;
	autoComplete?: string;
	inputProps?: Mui.InputBaseComponentProps;
}

/**
 * Add Member modal field — label-above-input layout per the Figma design (the floating-label
 * MUI default and the shared FormField don't match: the Figma puts a small grey label above a
 * plain bordered input).
 */
export const LabeledField: React.FC<Props> = ({
	label,
	value,
	onChange,
	required = false,
	error = false,
	helperText,
	type = "text",
	autoComplete,
	inputProps,
}) => {
	const { classes } = useStyles();
	return (
		<div>
			<Mui.Typography component="label" className={classes.label}>
				{label}
				{required && <span className={classes.asterisk}>*</span>}
			</Mui.Typography>
			<Mui.TextField
				fullWidth
				variant="outlined"
				className={classes.input}
				value={value}
				onChange={onChange}
				type={type}
				error={error}
				autoComplete={autoComplete}
				inputProps={inputProps}
			/>
			{error && helperText && (
				<Mui.Typography className={classes.error}>{helperText}</Mui.Typography>
			)}
		</div>
	);
};
